import line531 from "../../assets/BearishOSSales/Line 531@2x.png";
import line532 from "../../assets/BearishOSSales/Line 532@2x.png";
import line533 from "../../assets/BearishOSSales/Line 533@2x.png";
import line535 from "../../assets/BearishOSSales/Line 535@2x.png";

import back4993 from "../../assets/BearishOSSales/Group 4993@2x.png";
import back4994 from "../../assets/BearishOSSales/Group 4994@2x.png";
import back4995 from "../../assets/BearishOSSales/Group 4995@2x.png";
import back4996 from "../../assets/BearishOSSales/Group 4996@2x.png";

const ITRatingData = [
  {
    percent: "52%",
    linecolor: line535,
    content: "Reported a increase in team collobration",
    backgroundimg: back4993,
  },
  {
    percent: "41%",
    linecolor: line531,
    content: "Reported an increase in overall code quality",
    backgroundimg: back4994,
  },
  {
    percent: "25%",
    linecolor: line532,
    content: "Reported reduction in overall debugging time",
    backgroundimg: back4995,
  },
  {
    percent: "29%",
    linecolor: line533,
    content: "Reported a decrease in overall development cycles",
    backgroundimg: back4996,
  },
];
export default ITRatingData;
